import type { DashboardPerScopeValueResponse, DashboardResult } from '@api/domain/types';

interface UseManageDashboardOverviewBottomBlockParams {
  worst: DashboardPerScopeValueResponse | null;
  best: DashboardPerScopeValueResponse | null;
}

export const useManageDashboardOverviewBottomBlock = ({ worst, best }: UseManageDashboardOverviewBottomBlockParams) => {
  const worstResults: DashboardResult[] | null = worst?.results ?? null;
  const bestResults: DashboardResult[] | null = best?.results ?? null;

  return { worstResults, bestResults };
};
